<script>
//import remixiconUrl from './remixicon.symbol.svg'

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
    }
  },
}
</script>

<template>
  <button
    class="menubar__button menu-item"
    :class="{'is-active': isActive ? isActive(): null }"
    @click="action"
    :title="title"
  >
    <span v-if="title=='하이라이트'">
      <i :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='purple'">
      <i style="color:#583193" :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='red'">
      <i style="color:#f13a3a" :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='green'">
      <i style="color:#1b915a" :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='blue'">
      <i style="color:#3f51b5" :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='yellow'">
      <i style="color:#f17425" :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='grey'">
      <i style="color:#5a6d90" :class="`mdi mdi-${icon}`"></i>
    </span>
    <span v-else-if="title=='dark'">
      <i style="color:#454545" :class="`mdi mdi-${icon}`"></i>
    </span>
    <!-- 폰트크기 -->
    <span v-else-if="title=='폰트 10'" class="font-size-12">
      10p
    </span>
    <span v-else-if="title=='폰트 11'" class="font-size-12">
      11p
    </span>
    <span v-else-if="title=='폰트 12'" class="font-size-12">
      12p
    </span>
    <span v-else-if="title=='폰트 14'" class="font-size-12">
      14p
    </span>
    <span v-else-if="title=='폰트 16'" class="font-size-12">
      16p
    </span>
    <span v-else-if="title=='폰트 18'" class="font-size-12">
      18p
    </span>
    <span v-else-if="title=='알통 샘플'">
      <i :class="`mdi mdi-${icon} text-success`"></i>
    </span>
    <span v-else-if="title=='제목있는표만들기'">
      <i :class="`mdi mdi-${icon} text-white`"></i>
    </span>
    <span v-else-if="title=='제목없는표만들기'">
      <i :class="`mdi mdi-${icon} text-white`"></i>
    </span>
    <span v-else-if="title=='가로2칸'">
      <i :class="`mdi mdi-${icon} text-white`"></i>
    </span>
    <span v-else-if="title=='테이블 삭제'">
      <i :class="`mdi mdi-${icon} text-danger`"></i>
    </span>
    <span v-else-if="title=='이미지 왼쪽'">
      <i :class="`mdi mdi-${icon} text-yellow`"></i>
    </span>
    <span v-else-if="title=='이미지 기본'">
      <i :class="`mdi mdi-${icon} text-yellow`"></i>
    </span>
    <span v-else-if="title=='이미지 오른쪽'">
      <i :class="`mdi mdi-${icon} text-yellow`"></i>
    </span>
    <span v-else-if="title=='회원전체추가'">
      <i :class="`mdi mdi-${icon} text-warning`"></i>
    </span>
    <span v-else-if="title=='회원1명만추가'">
      <i :class="`mdi mdi-${icon} text-warning`"></i>
    </span>
    <span v-else>
      <i :class="`mdi mdi-${icon}`"></i>
    </span>
    <!--<img :src="`../icons/${icon}.svg`" class="icon" alt="">-->
  </button>
</template>